var _path, _line, _line2, _path2, _circle, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticial({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44573",
    "data-name": "Group 44573",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.535,
    height: 21.5,
    viewBox: "0 0 20.535 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89196",
    "data-name": "Path 89196",
    d: "M8.029,20.182H1.551a.8.8,0,0,1-.8-.8V1.551a.8.8,0,0,1,.8-.8H9.536A.8.8,0,0,1,10.1.984l4.973,4.971a.8.8,0,0,1,.235.567V8.265",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_344",
    "data-name": "Line 344",
    x2: 4.301,
    transform: "translate(3.551 10.466)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_345",
    "data-name": "Line 345",
    x2: 2.508,
    transform: "translate(3.551 14.64)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89197",
    "data-name": "Path 89197",
    d: "M9.621.755V5.469a.8.8,0,0,0,.8.8h4.845",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_377",
    "data-name": "Ellipse 377",
    cx: 5.378,
    cy: 5.378,
    r: 5.378,
    transform: "translate(9.029 9.994)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_346",
    "data-name": "Line 346",
    y2: 0.3,
    transform: "translate(14.406 12.813)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    y2: 3,
    transform: "translate(14.406 14.936)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticial);
export default __webpack_public_path__ + "static/media/particial.7efb187000b12cc8ca120e2e3b6c1800.svg";
export { ForwardRef as ReactComponent };